import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import profAnamaria from "@/assets/orto/prof-anamaria.jpg.asset.json";

const TITLE = "Pós em Fisioterapia em Gerontologia | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação online em Gerontologia: 14 módulos, 360h, reconhecida pelo MEC. Avaliação, prevenção de quedas e reabilitação do idoso.";
const URL = "https://fisioemortopedia.com.br/geronto2";

export const Route = createFileRoute("/geronto2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: GerontoLP2,
});

function GerontoLP2() {
  return (
    <PosVNextLP
      product="geronto"
      heroEyebrow="Pós-Graduação · 100% online · MEC"
      heroTitle="Fisioterapia em Gerontologia que devolve autonomia ao idoso"
      heroTitleHighlight="devolve autonomia"
      heroSubtitle="Avaliação, prevenção de quedas, fragilidade e reabilitação funcional do idoso, com protocolos atualizados e raciocínio clínico aplicado ao envelhecimento."
      promessas={[
        "Avaliar funcionalidade, fragilidade e risco de queda",
        "Prescrever exercício seguro e progressivo no idoso",
        "Conduzir reabilitação pós-fratura e pós-cirúrgica",
        "Trabalhar com equipe multi em ILPI, domicílio ou clínica",
      ]}
      personas={[
        {
          titulo: "Fisio em domicílio ou ILPI",
          desc: "Que quer estruturar avaliação e tratamento do idoso com método e segurança.",
        },
        {
          titulo: "Fisio em consultório",
          desc: "Que vê cada vez mais idosos chegando e quer raciocínio específico pra essa fase.",
        },
        {
          titulo: "Fisio que quer especialização",
          desc: "Que busca certificação MEC e referência nacional em envelhecimento ativo.",
        },
      ]}
      coordenadorNome="Anamaria Siriani"
      coordenadorFoto={profAnamaria.url}
      coordenadorQuote="Envelhecer não é diagnóstico. É contexto. E todo idoso merece um plano feito pra ele."
      coordenadorBio="Coordenadora da pós em Fisioterapia em Gerontologia da FEO. Especialista em envelhecimento, fragilidade e reabilitação funcional, com ampla experiência clínica e formação de fisioterapeutas em todo o Brasil."
      ementaSubtitle="Grade completa, professores e cronograma da pós em Gerontologia."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
